var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClarityFileGroupSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 6.66669H8.66667C8.48986 6.66669 8.32029 6.73693 8.19526 6.86195C8.07024 6.98697 8 7.15654 8 7.33335V22C8 22.1768 8.07024 22.3464 8.19526 22.4714C8.32029 22.5964 8.48986 22.6667 8.66667 22.6667H20.6667C20.8435 22.6667 21.013 22.5964 21.1381 22.4714C21.2631 22.3464 21.3333 22.1768 21.3333 22V7.33335C21.3333 7.15654 21.2631 6.98697 21.1381 6.86195C21.013 6.73693 20.8435 6.66669 20.6667 6.66669ZM18.6667 17.3334H10.6667V16H18.6667V17.3334ZM18.6667 14.6667H10.6667V13.3334H18.6667V14.6667ZM18.6667 12H10.6667V10.6667H18.6667V12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16V2.66665H16V1.99998C16 1.82317 15.9298 1.6536 15.8047 1.52858C15.6797 1.40355 15.5101 1.33331 15.3333 1.33331H3.33333C3.15652 1.33331 2.98695 1.40355 2.86193 1.52858C2.7369 1.6536 2.66666 1.82317 2.66666 1.99998V16.6666C2.66666 16.8435 2.7369 17.013 2.86193 17.1381C2.98695 17.2631 3.15652 17.3333 3.33333 17.3333H4V16Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 18.6667V5.33333H18.6667V4.66667C18.6667 4.48986 18.5964 4.32029 18.4714 4.19526C18.3464 4.07024 18.1768 4 18 4H6C5.82319 4 5.65362 4.07024 5.5286 4.19526C5.40357 4.32029 5.33334 4.48986 5.33334 4.66667V19.3333C5.33334 19.5101 5.40357 19.6797 5.5286 19.8047C5.65362 19.9298 5.82319 20 6 20H6.66667V18.6667Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarityFileGroupSolid);
export default __webpack_public_path__ + "static/media/clarityFileGroupSolid.61c369278d79d8ffafeee880e26a07a7.svg";
export { ForwardRef as ReactComponent };